import React, { useEffect, useState } from 'react';
import { Box, CardHeader, CardContent, Autocomplete, Card, Container, FormControl, Typography, TextField, InputLabel, Select, MenuItem, Button } from '@mui/material';
import moment from 'moment-timezone';
import { getMe, updateSettings } from '../../utils/meUtil';  // Adjust path
import { useAuth } from "../../auth/AuthContext";

export default function Settings() {
    const { account, getAccessToken } = useAuth();
    const [defaultTz, setDefaultTz] = useState('');
    const [loading, setLoading] = useState(true);
    const [timezones, setTimezones] = useState<string[]>([]);

    useEffect(() => {
        const tzList = moment.tz.names();  // Full dynamic list
        setTimezones(tzList.sort());  // Sort alphabetically

        (async () => {
            try {
                const token = await getAccessToken!();
                const me = await getMe(token!);
                setDefaultTz(me.defaultTimezone || moment.tz.guess());
            } catch {}
            setLoading(false);
        })();
    }, []);

    const handleSave = async () => {
        try {
            const token = await getAccessToken!();
            await updateSettings({ defaultTimezone: defaultTz }, token!);
            alert('Saved!');
        } catch {
            alert('Save failed');
        }
    };

    return (
        <Box sx={{ width: "30vw", mx: "auto", mt: 6, px: 2 }}>
            <Card>
                <CardHeader title="User Settings"/>
                <CardContent>
                    <Autocomplete
                        value={defaultTz}
                        onChange={(event, newValue) => setDefaultTz(newValue || '')}
                        options={timezones}
                        renderInput={(params) => <TextField {...params} label="Default Timezone" />}
                        disabled={loading}
                        fullWidth
                    />
                </CardContent>
                <Button onClick={handleSave} disabled={loading}>Save</Button>
            </Card>
        </Box>
    );
}